import React from "react";
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Divider,
  TablePagination,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PendingIcon from "@mui/icons-material/Pending";
import InventoryIcon from "@mui/icons-material/Inventory";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Chip from "@mui/material/Chip";
import Loader from "../../layout/Loader";
import OrderList from "../OrderList";

const OrderTabsAndList = ({
  tabValue,
  handleTabChange,
  orders,
  loading,
  ptLoading,
  dealerLoading,
  order,
  orderBy,
  handleRequestSort,
  formatDate,
  setRefresh,
  totalOrders,
  page,
  handleChangePage,
  limit,
  handleChangeRowsPerPage,
}) => {
  const getTabIcon = (index) => {
    const icons = [
      <ShoppingCartIcon />,
      <PendingIcon />,
      <InventoryIcon />,
      <CheckCircleIcon />,
      <LocalShippingIcon />,
    ];
    return icons[index];
  };

  const getTabColor = (index) => {
    const colors = ["default", "warning", "info", "success", "primary"];
    return colors[index];
  };

  return (
    <>
      <Paper
        sx={{
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(20px)",
          borderRadius: 3,
          mb: 3,
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              minWidth: 140,
              fontWeight: 600,
              py: 2,
              "&.Mui-selected": {
                color: "#1e3c72",
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#1e3c72",
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
          }}
        >
          {[
            "All Orders",
            "Ready to Process",
            "Processing",
            "Processed",
            "Delivered",
          ].map((label, index) => (
            <Tab
              key={label}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {getTabIcon(index)}
                  {label}
                  {index === tabValue && (
                    <Chip
                      size="small"
                      label={totalOrders || 0}
                      color={getTabColor(index)}
                      sx={{ ml: 1 }}
                    />
                  )}
                </Box>
              }
            />
          ))}
        </Tabs>
      </Paper>
      <Paper
        sx={{
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(20px)",
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        {loading || ptLoading || dealerLoading ? (
          <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
            <Loader />
          </Box>
        ) : (
          <>
            <OrderList
              p={orders}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              setRefresh={setRefresh}
              formatDate={formatDate}
            />
            <Divider />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                p: 2,
                background: "rgba(248, 250, 252, 0.8)",
              }}
            >
              <TablePagination
                component="div"
                count={totalOrders || 0}
                page={page - 1}
                onPageChange={handleChangePage}
                rowsPerPage={limit}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  "& .MuiTablePagination-select": {
                    borderRadius: 1,
                  },
                  "& .MuiTablePagination-actions button": {
                    borderRadius: 1,
                  },
                }}
              />
            </Box>
          </>
        )}
      </Paper>
    </>
  );
};

export default OrderTabsAndList;